enum UserRolesEnum {
  Broker = 'Broker',
  Investor = 'Investor',
  BrokerAndInvestor = 'Broker & Investor',
}

export default UserRolesEnum;
